import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommonService } from '../../shared/services/common.service';

@Component( {
  selector: 'ngx-app-tracking',
  templateUrl: './tracking.component.html',
  styleUrls: [ './tracking.component.scss' ],
} )
export class TrackingComponent implements OnInit {
  trackingForm: FormGroup;
  submitted: boolean;
  idStatusPackage = 0;
  notFound = true;
  statuses = [
    'En Miami',
    'En transito',
    'Listo para entrega',
    'En camino a reparto',
    'Entregado',
    'Prealertar',
  ];

  constructor(
    private formBuilder: FormBuilder,
    private commonService: CommonService,
  ) {
    this.createForm();
  }

  get f() {
    return this.trackingForm.controls;
  }

  ngOnInit(): void {
  }

  onSubmit(): void {

    this.submitted = true;
    if ( this.trackingForm.valid ) {
      this.commonService.tracking( this.trackingForm.value ).subscribe( response => {
        this.notFound = response.data.length;
        this.idStatusPackage = response.data[ 0 ]?.id_status_package;
      } );
    }
  }

  private createForm(): void {
    this.trackingForm = this.formBuilder.group( {
      searchCode: [ '', [ Validators.required ] ],
    } );
  }
}
